<template>
    <div id="test-section" class="search-select__container">
        <div v-if="isSelectAll" class="search-select__select">
          <div class="search-select__select-all search-select__select-common">
            <button
                v-if="classUpKeyboard !== ''"
                :data-sn-up="classUpKeyboard"
                :data-sn-down="classDownSelectAll"
                @click="$emit('select-all')"
                type="button"
                class="btn btn-outline-primary focusable target-select-all"
            >
              Select All
            </button>
            <button
                v-if="classUpKeyboard === ''"
                @click="$emit('select-all')"
                type="button"
                class="btn btn-outline-primary focusable target-select-all"
            >
              Select All
            </button>
          </div>
          <div class="search-select__deselect-all search-select__select-common">
            <button
                @click="handleDeselectAll"
                :data-sn-down="classDownSelectAll"
                type="button"
                class="btn btn-outline-primary focusable"
            >
              Deselect All
            </button>
          </div>
        </div>
      <div class="search-select__title">
        {{ title }}
      </div>
      <div class="search-select__search">
        <div class="input-group search-select__search__container">
          <input
              ref="refSearchInput"
              v-model="dataSearch"
              type="text"
              class="form-control focusable"
              placeholder=""
              :data-sn-down="classDownSelectAll"
              :class="classSearchInput"
              @keyup="handleSearch"
          >
          <div
              class="input-group-append"
              :data-sn-down="classDownKeyboard"
              :data-sn-right="classDownKeyboard"
              @keyup="handleSearch"
          >
            <button
                @click="handleSearch"
                ref="refSearchBtn"
                class="search-select__search__submit focusable"
            >Search</button>
            <button
                @click="handleClearSearch"
                class="btn btn-danger search-select__search__clear focusable"
            >Clear</button>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: ''
    },
    isSelectAll: {
      type: Boolean,
      default: true
    },
    classDownKeyboard: {
      type: String,
      default: ''
    },
    classUpKeyboard: {
      type: String,
      default: ''
    },
    classDownSelectAll: {
      type: String,
      default: ''
    },
    classSearchInput: {
      type: String,
      default: ''
    },
    isFocusSearch: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      dataSearch: ''
    }
  },
  watch: {
    isFocusSearch(data) {
      this.$refs.refSearchInput.focus();
    }
  },
  methods: {
    handleDeselectAll() {
      this.dataSearch = '';
      this.$emit('deselect-all');
    },
    handleSearch() {
      this.$emit('search', this.dataSearch);
    },
    handleClearSearch() {
      this.dataSearch = '';
      this.$emit('search', this.dataSearch);
    }
  }
}
</script>

<style scoped lang="scss" src="@/assets/scss/retail/section-search-select.scss"/>
